module.exports = __webpack_public_path__ + "static/img/宣传品设计-企业&产品手册设计.5a5b0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10003/宣传品设计-企业&产品手册设计.png
// module id = V7sd
// module chunks = 1